/*
 * @Date: 2019-07-22 09:59:17
 * @LastEditTime: 2020-12-24 20:04:43
 * @LastEditors: hai.zhang
 */
import Vue from 'vue'
import Vuex from 'vuex'
import cart from './modules/cart/index'
import user from './modules/user/index'
import area from './modules/area/index'
import digits from './modules/digits/index'
import org from './modules/org/index'
import process from './modules/process'
import pageText from './modules/page-text'
import checkAuth from './modules/checkAuth/index'
import requireList from './modules/require-list/index'
import mallRule from './modules/mallRule/index'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    checkAuth,
    cart,
    user,
    area,
    digits,
    org,
    process,
    pageText,
    requireList,
    mallRule
  }
})

export default store
